/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useState } from "react";
import './Detail.css';
import { useMutation } from "@apollo/client";
import { useLocation, useParams } from 'react-router-dom'
import { BUYEREMAIL } from "../../Mutation/EmailMutation";
import { useGetCarSaleHistoryQuery } from "../../redux/createApi";
import toast from 'react-hot-toast';
import { Card, Col, Container, Row, Button, Table } from "react-bootstrap";
import { MdOutlineShowChart } from "react-icons/md";
import { FaCamera, FaInfoCircle, FaCalculator, FaHistory, FaCopy, FaDotCircle, FaChevronDown, FaChevronUp } from "react-icons/fa";


const Detail = () => {
  const { id } = useParams();
  const { state } = useLocation();
  const carData = state?.data || state?.vehicle || {};
  const IsAuthentic = localStorage.getItem('accessToken');
  const [sentEmail, { data: emailData, loading: EmailLoading, error: emailError }] = useMutation(BUYEREMAIL);
  const [activeImage, setActiveImage] = useState(carData?.link_img_small?.[0] || "");
  const [showSalesHistory, setShowSalesHistory] = useState(false);
  const { data: salesHistoryData } = useGetCarSaleHistoryQuery(
    carData?.lot_id,
    {
      skip: !carData?.lot_id,
    }
  );
  const Salesdata = salesHistoryData?.data

  const SentEmail = () => {
    sentEmail({ variables: { url: `https://automotor.dev-bt.xyz/detail/${id}` } })
      .then((response) => {
        if (response && response?.data) {
          toast.success("Email Sent Successfully")
        }
      });
  }

  console.log(carData, 'carData');

  const isFutureAuction = carData?.auction_date ? new Date(carData.auction_date) > new Date() : false;

  const formatCurrency = (val) => {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: carData?.currency || 'USD' }).format(val);
  }

  return (
    <div className="detail-page-wrapper">
      <Container fluid className="px-lg-5 py-3">

        <div className="header-top-section mb-3">
          <div className="d-flex align-items-center flex-wrap gap-3 mb-2">
            <h2 className="car-main-title mb-0">{carData?.title}</h2>
            <div className="vin-badge-container d-flex align-items-center gap-2">
              <span className="vin-label px-2 py-1 rounded bg-light border">
                {carData?.vin} <FaCopy className="ms-1 text-muted cursor-pointer" title="Copy VIN" />
              </span>
              <span className="iaai-badge px-2 py-1 rounded text-white fw-bold bg-danger text-uppercase">{carData?.base_site}</span>
            </div>
          </div>
          <div className="header-meta-info d-flex flex-wrap gap-4 text-muted small fw-bold">
            <span>Location: <span className="text-dark">{carData?.location}</span></span>
            <span>Vehical Type: <span className="text-dark">{carData?.vehicle_type}</span></span>
            <span>Drive: <span className="text-dark">{carData?.drive}</span></span>
          </div>
        </div>

        <div className="action-tabs-bar d-flex justify-content-between align-items-center border-top border-bottom py-2 mb-3 bg-white px-3 rounded shadow-sm">
          <div className="d-flex gap-3 h-100 align-items-center">
            <div
              className={`action-tab d-flex align-items-center gap-2 cursor-pointer ${showSalesHistory ? 'active' : ''}`}
              onClick={() => setShowSalesHistory(!showSalesHistory)}
            >
              <FaHistory className="text-muted" />
              <span className="fw-bold">Sales History</span>
              <span className="count-badge rounded-circle px-2 py-0 bg-light border small">{Salesdata?.length || 0}</span>
              {showSalesHistory ? <FaChevronUp className="small text-muted" /> : <FaChevronDown className="small text-muted" />}
            </div>

          </div>
          <div className="auction-date-info d-flex align-items-center gap-2 small">
            <FaDotCircle className="text-danger" />
            <span className="text-muted fw-bold">Auction date</span>
            <span className="text-danger fw-bold">{new Date(carData?.auction_date).toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' })}</span>
          </div>
        </div>

        {showSalesHistory && (
          <Card className="sales-history-card border-0 shadow-sm mb-4 card w-100 ms-0">
            <Card.Header className="bg-white border-bottom py-3">
              <h6 className="mb-0 fw-bold d-flex align-items-center">
                <MdOutlineShowChart className="me-2 text-muted" /> Sales History
              </h6>
            </Card.Header>
            <Card.Body className="p-0">
              <Table responsive hover className="mb-0 sales-table">
                <thead className="bg-light">
                  <tr>
                    <th className="border-0 small text-muted text-uppercase fw-bold">Auction</th>
                    <th className="border-0 small text-muted text-uppercase fw-bold">Title</th>
                    <th className="border-0 small text-muted text-uppercase fw-bold">Lot #</th>
                    <th className="border-0 small text-muted text-uppercase fw-bold text-center">Final bid</th>
                    <th className="border-0 small text-muted text-uppercase fw-bold text-center">Odometer</th>
                    <th className="border-0 small text-muted text-uppercase fw-bold text-center">Status</th>
                    <th className="border-0 small text-muted text-uppercase fw-bold text-center">Seller</th>
                  </tr>
                </thead>
                <tbody>
                  {

                    Salesdata?.length > 0 ? (
                      Salesdata?.map((item, index) => (
                        <tr key={index} className="align-middle">
                          <td className="ps-3"><span className="badge bg-danger px-3 py-2">{item.auction_type}</span></td>
                          <td className="fw-bold text-muted">{item.title}</td>
                          <td><a href="#" className="text-primary text-decoration-none fw-bold">{item.lot_id}</a></td>
                          <td className="text-center">
                            <span className={`status-badge px-3 py-1 rounded small fw-bold bg-success-light text-success`}>
                              {formatCurrency(item.price_new)}
                            </span>
                          </td>
                          <td className="text-center fw-bold text-muted">{item.odometer}</td>
                          <td className="text-center">
                            <span className={`status-badge px-3 py-1 rounded small fw-bold ${item.status === 'Sold' ? 'bg-success-light text-success' : 'bg-danger-light text-danger'}`}>
                              {item.status}
                            </span>
                          </td>
                          <td className="text-center text-muted fw-bold text-capitalize">{item.seller_type}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={7} className="text-center">No Sales History Found</td>
                      </tr>
                    )
                  }
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        )}

        <Row>

          <Col lg={6} md={12} className="px-2 mb-4">
            <div className="main-image-container position-relative rounded overflow-hidden shadow-sm">
              <img src={activeImage} alt={carData?.title} className="w-100 main-vehicle-img" />
              <div className="gallery-overlay d-flex justify-content-end p-2 gap-2">
                <Button variant="dark" size="sm" className="gallery-btn">
                  View {carData?.link_img_small?.length} Photos
                </Button>
                {carData?.iaai_360 && (
                  <Button variant="dark" size="sm" className="gallery-btn" onClick={() => window.open(carData?.iaai_360, '_blank')}>
                    <FaCamera className="me-1" /> 360° View
                  </Button>
                )}
              </div>
            </div>
            <Row className="mt-2 g-2">
              {carData?.link_img_small?.map((img, index) => (
                <Col key={index} xs={2} sm={2} md={2} lg={2} xl={2} className="thumbnail-col">
                  <div
                    className={`thumbnail-item rounded overflow-hidden cursor-pointer ${activeImage === img ? 'active' : ''}`}
                    onClick={() => setActiveImage(img)}
                  >
                    <img src={img} alt={`Thumbnail ${index}`} className="w-100 h-100 object-fit-cover" />
                  </div>
                </Col>
              ))}
            </Row>
          </Col>

          {/* Middle Column: Detailed Information */}
          <Col lg={3} md={12} className="px-2 mb-4">
            {/* Lot/VIN Info */}
            <Card className="info-card mb-3 shadow-sm border-0">
              <Card.Body className="p-0">
                <Table borderless className="info-table mb-0">
                  <tbody>
                    <tr>
                      <td className="info-label">Lot ID</td>
                      <td className="info-value text-end">{carData?.lot_id}</td>
                    </tr>
                    <tr>
                      <td className="info-label">VIN</td>
                      <td className="info-value text-end">{carData?.vin}</td>
                    </tr>
                    <tr>
                      <td className="info-label">Seller</td>
                      <td className="info-value text-end">
                        <span className="seller-badge">{carData?.seller || '-'}</span>
                      </td>
                    </tr>
                    <tr>
                      <td className="info-label">Document</td>
                      <td className="info-value text-end text-success fw-bold">
                        {carData?.document_old}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Card.Body>
            </Card>

            {/* Damage/Condition Info */}
            <Card className="info-card mb-3 shadow-sm border-0">
              <Card.Body className="p-0">
                <Table borderless className="info-table mb-0">
                  <tbody>
                    {carData?.damage_pr && (
                      <tr>
                        <td className="info-label text-muted">Primary damage</td>
                        <td className="info-value text-end">{carData?.damage_pr}</td>
                      </tr>
                    )}
                    {carData?.damage_sec && (
                      <tr>
                        <td className="info-label text-muted">Secondary damage</td>
                        <td className="info-value text-end">{carData?.damage_sec}</td>
                      </tr>
                    )}
                    {carData?.odometer && (
                      <tr>
                        <td className="info-label text-muted">Odometer</td>
                        <td className="info-value text-end fw-bold">{carData?.odometer} {carData?.odometer_index}</td>
                      </tr>
                    )}
                    {carData?.status && (
                      <tr>
                        <td className="info-label text-muted">Status</td>
                        <td className="info-value text-end fw-bold">{carData?.status}</td>
                      </tr>
                    )}
                    {carData?.keys && (
                      <tr>
                        <td className="info-label text-muted">Keys</td>
                        <td className="info-value text-end">{carData?.keys}</td>
                      </tr>
                    )}
                    {carData?.airbag && (
                      <tr>
                        <td className="info-label text-muted">Airbag</td>
                        <td className="info-value text-end">{carData?.airbag}</td>
                      </tr>
                    )}
                    <tr>
                      <td className="info-label text-muted">ACV / ERC</td>
                      <td className="info-value text-end fw-bold">
                        {formatCurrency(carData?.cost_priced)} / {formatCurrency(carData?.cost_repair)}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Card.Body>
            </Card>

            {/* Technical Specifications */}
            <Card className="info-card mb-3 shadow-sm border-0">
              <Card.Body className="p-0">
                <Table borderless className="info-table mb-0">
                  <tbody>
                    <tr>
                      <td className="info-label text-muted">Exterior color</td>
                      <td className="info-value text-end">{carData?.color}</td>
                    </tr>
                    <tr>
                      <td className="info-label text-muted">Engine</td>
                      <td className="info-value text-end">{carData?.engine}</td>
                    </tr>
                    <tr>
                      <td className="info-label text-muted">Transmission</td>
                      <td className="info-value text-end">{carData?.transmission}</td>
                    </tr>
                    <tr>
                      <td className="info-label text-muted">Fuel Type</td>
                      <td className="info-value text-end">{carData?.fuel}</td>
                    </tr>
                    <tr>
                      <td className="info-label text-muted">Drive Type</td>
                      <td className="info-value text-end">{carData?.drive}</td>
                    </tr>
                    <tr>
                      <td className="info-label text-muted">Cylinders</td>
                      <td className="info-value text-end">{carData?.cylinders}</td>
                    </tr>
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>

          {/* Right Column: Bid & Calculator */}
          <Col lg={3} md={12}>
            {/* Final Bid Card */}
            <Card className="bid-card border-theme-red mb-3 shadow-sm text-center">
              <Card.Body className="py-4">

                <div
                  className={`mb-1 fs-4 ${isFutureAuction ? "text-success" : "text-danger"
                    }`}
                >
                  {isFutureAuction ? "Current Bid" : "Final Bid"}
                </div>

                <h2
                  className={` mb-3 ${isFutureAuction ? "text-success" : "text-danger"
                    }`}
                >
                  {formatCurrency(carData?.current_bid || 0)}
                </h2>

              </Card.Body>
            </Card>

            {/* Price Estimator */}
            <Card className="calculator-card mb-3 shadow-sm border-0">
              <Card.Header className="bg-white border-0 pt-3 pb-0 d-flex justify-content-between align-items-center">
                <h6 className="mb-0 fw-bold small d-flex align-items-center">
                  <FaCalculator className="me-2 text-muted" /> Price Details
                </h6>
                <div className="text-primary fw-bold small">{carData?.currency?.toUpperCase()}</div>
              </Card.Header>
              <Card.Body className="pt-2">
                <div className="estimation-breakdown small">
                  <div className="d-flex justify-content-between mb-1">
                    <span style={{ fontSize: '13px' }} className="text-muted fw-bold">Bid</span>
                    <span style={{ fontSize: '13px' }} className="fw-bold ">{formatCurrency(carData?.current_bid || 0)}</span>
                  </div>
                  <div className="d-flex justify-content-between mb-1">
                    <span style={{ fontSize: '13px' }} className="text-muted fw-bold">Retail (ACV)</span>
                    <span style={{ fontSize: '13px' }} className="fw-bold ">{formatCurrency(carData?.cost_priced)}</span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span style={{ fontSize: '13px' }} className="text-muted fw-bold">Repair</span>
                    <span style={{ fontSize: '13px' }} className="fw-bold">{formatCurrency(carData?.cost_repair)}</span>
                  </div>
                </div>
              </Card.Body>
            </Card>

            {/* Sale Information */}
            <Card className="calculator-card shadow-sm border-0">
              <Card.Header className="bg-white border-0 pt-3 pb-0">
                <h6 className="mb-0 fw-bold small d-flex align-items-center">
                  <FaInfoCircle className="me-2 text-muted" /> Sale Info
                </h6>
              </Card.Header>
              <Card.Body className="pt-2 small">
                <div className="calc-item d-flex justify-content-between mb-2">
                  <span className="text-muted fw-bold" style={{ fontSize: '13px' }}>Date</span>
                  <span className="fw-bold" style={{ fontSize: '13px' }}>{new Date(carData?.auction_date).toLocaleDateString()}</span>
                </div>
                <div className="calc-item d-flex justify-content-between mb-2">
                  <span className="text-muted fw-bold" style={{ fontSize: '13px' }}>Auction</span>
                  <span className="fw-bold" style={{ fontSize: '13px' }}>{carData?.auction_type}</span>
                </div>
                <div className="calc-item d-flex justify-content-between mb-2">
                  <span className="text-muted fw-bold" style={{ fontSize: '13px' }}>Location</span>
                  <span className="fw-bold" style={{ fontSize: '13px' }}>{carData?.location}</span>
                </div>
                <div className="calc-item d-flex justify-content-between mb-2">
                  <span className="text-muted fw-bold" style={{ fontSize: '13px' }}>Type</span>
                  <span className="fw-bold" style={{ fontSize: '13px' }}>{carData?.vehicle_type}</span>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {carData?.video && (
          <Row className="mt-4">
            <Col>
              <h5 className="fw-bold mb-3">Vehicle Video</h5>
              <div className="rounded overflow-hidden shadow-sm border">
                <video controls width="100%" className="d-block">
                  <source src={carData?.video} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </Col>
          </Row>
        )}

        {(carData?.latitude || carData?.longitude || carData?.location) && (
          <Row className="mt-4">
            <Col>
              <h5 className="fw-bold mb-3">Vehicle Location</h5>
              <div className="map-container rounded overflow-hidden shadow-sm border" style={{ height: '400px' }}>
                <iframe
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  loading="lazy"
                  allowFullScreen
                  src={`https://maps.google.com/maps?q=${carData?.latitude && carData?.longitude
                    ? `${carData.latitude},${carData.longitude}`
                    : encodeURIComponent(carData?.location_offsite || carData?.location || "")
                    }&z=15&output=embed`}
                ></iframe>
              </div>
            </Col>
          </Row>
        )}

      </Container>
    </div>
  );

};

export default Detail;